










import Vue from 'vue';
import ErrorTemplate from '@/components/templates/error/ErrorTemplate.vue';
import { contentServices } from '@/services/contentService';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import { SpinnerState } from '@/enums/spinnerState';
import { MessageType } from '@/enums/messageType';
import { dialogueMessageService } from '@/services/dialogueMessageService';
import { PageContent } from '@/api/interfaces/content/app/pageContent';
import router from '@/router';
import { ErrorContent } from '@/api/interfaces/content/app/errorContent';
import { AppContent } from '@/api/interfaces/content/app/appContent';

export default Vue.extend({
    name: 'Error',
    components: {
        ErrorTemplate,
        SpinnerArea,
    },
    props: {
        /**
         * The name of the pageContent property holding data
         * for the respective specific error
         */
        contentProperty: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            spinner: SpinnerState.off,
            errorContent: null as PageContent | null,
        };
    },
    created() {
        if (this.$route.query.code === 'unauthorized') {
            dialogueMessageService.show('unauthorized', MessageType.error);
        }
    },
    async mounted() {
        this.spinner = SpinnerState.opaque;

        const content = await contentServices.app.requestContentOnce();
        this.errorContent = content.pages[
            this.contentProperty as keyof AppContent['pages']
        ] as ErrorContent;

        this.spinner = SpinnerState.off;
    },
    methods: {
        handleButtonBackToOverviewClick(): void {
            router.push('/');
        },
    },
});
